import palette from 'google-palette';
import Utils from '~/scripts/services/utils';
import Layer from '~/scripts/services/model/layer';

/**
 * @ngdoc directive
 * @name app.directive:gisPreview
 * @description
 * # gisPreview
 */
angular.module('app')
	.directive('gisPreview', /* @ngInject */ function ($timeout, $uibModal, API, NgMap) {
		return {
			templateUrl: '/templates/directives/gis-preview.html',
			restrict:    'E',
			replace:     true,
			link: (scope, element, attrs) => {
				const markerColors = [
					'blue',
					'red',
					'yellow',
					'green',
					'magenta',
					'cyan',
					'orange',
					'indigo',
					'grey',
					'black',
					'blue2',
					'white',
				];

				const baseColors = palette('mpn65', 16);
				let lastUsedBaseColor = 0, lastUsedMarkerColor = 0;

				const defaultStyles = {
					LineString:   {
						clickable:     true,
						strokeColor:   '_auto',
						strokeOpacity: 1,
						strokeWeight:  1.5,
					},
					Point:        {
						clickable: true,
						icon:      {
							url:        '_auto',
							scaledSize: { width: 12, height: 12 },
						},
					},
					Polygon:      {
						clickable:     true,
						fillColor:     '_auto',
						strokeColor:   '#000',
						strokeOpacity: 0.3,
						strokeWeight:  1,
					},
					MultiPolygon: {
						clickable:     true,
						fillColor:     '_auto',
						strokeColor:   '#000',
						strokeOpacity: 0.3,
						strokeWeight:  1,
					},
				};

				scope.map = null;
				scope.item = scope.$eval(attrs.item);

				scope.gis = {
					autoZoom:    true,
					initialZoom: 2,
					layers:      [],
				};

				const processPoints = (geometry, callback, thisArg) => {
					if (geometry instanceof google.maps.LatLng) {
						callback.call(thisArg, geometry);
					}
					else if (geometry instanceof google.maps.Data.Point) {
						callback.call(thisArg, geometry.get());
					}
					else {
						geometry.getArray().forEach(g => {
							processPoints(g, callback, thisArg);
						});
					}
				};

				const updateLayers = map => {
					angular.forEach(scope.gis.layers, layer => {
						if (layer.enabled) {
							if (!layer.loaded) {
								layer.loading = true;
								API.GISGetLayer(layer.id).then(res => {
									// inject layer property before load in GMaps in order to differentiate them
									angular.forEach(res.data.features, feature => {
										feature.properties.layer = layer;
									});
									map.data.addGeoJson(res.data);
									map.data.forEach(feature => {
										if (feature.getProperty('layer').id === layer.id) {
											feature.setProperty('visible', true);
										}
									});
									layer.loaded = true;
									layer.loading = false;
								});
							}
							else {
								map.data.forEach(feature => {
									if (feature.getProperty('layer').id === layer.id) {
										feature.setProperty('visible', true);
									}
								});
							}
						}
						else {
							map.data.forEach(feature => {
								if (feature.getProperty('layer').id === layer.id) {
									feature.setProperty('visible', false);
								}
							});
						}
					});
				};

				// Toggle selection for a given fruit by name
				scope.toogleSelectionLayer = () => {
					$timeout(() => {
						updateLayers(scope.map);
					});
				};

				scope.export = map => {
					map.data.toGeoJson(data => {
						Utils.download(angular.toJson(data), 'application/json', 'export-' + moment.utc().format('YYYYMMDDHHmmss') + '.json');
					});
				};

				scope.openModalLayerParameters = layer => {
					$uibModal.open({
						templateUrl: '/templates/modal/data-layer-parameters.html',
						controller:  'ModalGisLayerParametersCtrl',
						resolve:     {
							colors: () => markerColors,
							layer:  () => layer,
						},
					}).result.then(obj => {
						_.merge(layer, obj);

						scope.map.data.forEach(/**
																													 * @param {!google.maps.Data.Feature} feature
																													 */
							feature => {
								if (feature.getProperty('layer').id === layer.id) {
									scope.map.data.overrideStyle(feature, layer.style);
								}
							},
						);
					}, angular.noop);
				};

				NgMap.getMap().then(map => {
					scope.map = map;

					map.data.setStyle(feature => {
						const
							type = feature.getGeometry().getType(),
							layer = feature.getProperty('layer');

						if (angular.isUndefined(layer.style)) {
							if (type in defaultStyles) {
								layer.style = angular.copy(defaultStyles[type]);
								layer.type = type;

								if (layer.type === 'LineString' && layer.style.strokeColor === '_auto') {
									layer.style.strokeColor = '#' + baseColors[lastUsedBaseColor++];
								}

								if ((layer.type === 'Polygon' || layer.type === 'MultiPolygon') && layer.style.fillColor === '_auto') {
									layer.style.fillColor = '#' + baseColors[lastUsedBaseColor++];
								}

								if (layer.type === 'Point' && layer.style.icon.url === '_auto') {
									layer.style.icon.url = 'images/data/marker-' + markerColors[lastUsedMarkerColor++] + '.png';
								}
							}
							else {
								console.warn('Unsupported type:', layer.type);
							}
						}
						layer.style.visible = feature.getProperty('visible');

						return layer.style;
					});

					map.data.addListener('click', event => {
						$uibModal.open({
							templateUrl: '/templates/modal/data-layer-feature.html',
							controller:  /* @ngInject */ ($scope, $uibModalInstance, feature) => {
								$scope.properties = {};
								feature.forEachProperty((p, k) => {
									$scope.properties[k] = {
										value: p,
										type:  typeof p,
									};
								});

								$scope.cancel = () => {
									$uibModalInstance.dismiss();
								};
							},
							resolve:     {
								feature: () => event.feature,
							},
						});
					});

					map.data.addListener('mouseover', e => {
						if (e.feature.getGeometry().getType() === 'LineString') {
							const layer = e.feature.getProperty('layer');
							if (layer && layer.style.strokeWeight) {
								scope.map.data.overrideStyle(e.feature, { strokeWeight: layer.style.strokeWeight * 3 });
							}
						}
					});

					map.data.addListener('mouseout', e => {
						if (e.feature.getGeometry().getType() === 'LineString') {
							scope.map.data.overrideStyle(e.feature, { strokeWeight: e.feature.getProperty('layer').style.strokeWeight });
						}
					});

					// zoom to show all the features
					const bounds = new google.maps.LatLngBounds();
					map.data.addListener('addfeature', e => {
						if (scope.gis.autoZoom) {
							processPoints(e.feature.getGeometry(), bounds.extend, bounds);
							map.fitBounds(bounds);
						}
					});

					// map.addListener('idle', function() {
					// 	updateLayers(map);
					// });

					// map.overlayMapTypes.getAt(0).setOpacity(0.25);

					// $timeout(() => {
					scope.gis.layers.length = 0;
					API.GISListLayers(scope.item.kid).then(data => {
						angular.forEach(data.layers, l => {
							scope.gis.layers.push(Object.assign(new Layer(l.id), l));
						});
						updateLayers(map);
					});
					// });

					const mapTypeIds = [];
					for (let type in google.maps.MapTypeId) {
						mapTypeIds.push(google.maps.MapTypeId[type]);
					}
					mapTypeIds.push('OSM');

					map.setOptions({
						mapTypeControlOptions: {
							mapTypeIds: mapTypeIds,
						},
					});

					map.mapTypes.set('OSM', new google.maps.ImageMapType({
						getTileUrl: function (coord, zoom) {
							// See above example if you need smooth wrapping at 180th meridian
							return 'https://tile.openstreetmap.org/' + zoom + '/' + coord.x + '/' + coord.y + '.png';
						},
						tileSize:   new google.maps.Size(256, 256),
						name:       'OpenStreetMap',
						maxZoom:    18,
					}));
				});
			},
		};
	});
